

























































































import MenuItem from '@/components/Global/Menu/Item.vue';
import Dropdown from '@/components/Global/Menu/Dropdown.vue';
import Auth from '@/services/Auth';
import { Component, Vue } from 'vue-property-decorator';
import { Features } from '@/services/Features';
@Component({
	name: 'StaffMenu',
	components: {
		MenuItem,
		Dropdown,
	},
})
export default class StaffMenu extends Vue {
	private Auth: any;
	private readonly Features = Features;
	constructor() {
		super();
		this.Auth = Auth;
	}
}
